
import Component from '../../../assets/scripts/modules/component';
import fireCustomEvent from '../../../vendor/scripts/fabrique/modules/fire-custom-event';

function parseDate(yydmmddd) {
  const args = yydmmddd.split('-').map((arg) => Number(arg));
  return new Date(args[0] + 2000, args[1] - 1, args[2]);
}

class Link extends Component {
  init() {
    const role = this.element.getAttribute('data-role');

    if (role === 'add-to-calendar') {
      this.initAddEventToCalendarLink();
    } else if (role === 'invite-a-friend') {
      this.initInviteAFriendLink();
    } else if (role === 'follow-us') {
      this.initFollowUsLink();
    } else if (role === 'newsletter-subscribe') {
      this.initNewsletterSubscribeLink();
    } else if (role === 'copyright') {
      this.initCopyright();
    }
  }

  initAddEventToCalendarLink() {
    const onLinkClick = (event) => {
      event.preventDefault();
      fireCustomEvent('add-to-calendar:start', {
        minDate: parseDate(this.element.getAttribute('data-minDate')),
        maxDate: parseDate(this.element.getAttribute('data-maxDate')),
      });
    };

    this.element.addEventListener('click', onLinkClick);
  }

  initInviteAFriendLink() {
    const onLinkClick = (event) => {
      event.preventDefault();
      fireCustomEvent('invite-a-friend:start');
    };

    this.element.addEventListener('click', onLinkClick);
  }

  initFollowUsLink() {
    const onLinkClick = (event) => {
      event.preventDefault();
      fireCustomEvent('follow-us:start');
    };

    this.element.addEventListener('click', onLinkClick);
  }

  initNewsletterSubscribeLink() {
    const onLinkClick = (event) => {
      event.preventDefault();
      fireCustomEvent('newsletter-subscribe:start');
    };

    this.element.addEventListener('click', onLinkClick);
  }

  initCopyright() {
    const onLinkClick = (event) => {
      event.preventDefault();
      fireCustomEvent('copyright:start');
    };

    this.element.addEventListener('click', onLinkClick);
  }
}

for (const element of document.querySelectorAll('.link[data-role]')) {
  element.instance = new Link('link', element, { onLoad: true });
}



// WEBPACK FOOTER //
// ./website/components/atoms/link/link.js